import financialDataRegistryAgent from './agent';
import { VerificationResult } from './types';

export const getTaxInfoVerificationResult = ({ merchantId }: { merchantId: string }) => {
  return financialDataRegistryAgent
    .get<VerificationResult>(`public/external/api/v1/merchant/${merchantId}/tax-info/async-verification`)
    .then(response => response.data);
};
